export default "__VITE_ASSET__D4hK5iP$__"